module.exports = __webpack_public_path__ + "static/media/Kuusamo_teksti_500x500_elokuu.65488f93.jpg";